import { ReactElement } from 'react';
import EmissionHistoryTable from 'domains/emission/components/emission-history-table/emission-history-table.component';
import { SContainer } from './emission-history.page.style';

const ReportingEmissionHistoryPage = (): ReactElement => (
  <SContainer>
    <EmissionHistoryTable />
  </SContainer>
);

export default ReportingEmissionHistoryPage;
